import * as types from './window.actionTypes';
import * as commonActionType from '@common/store/common/common.actionsType';
import store from '@common/store/store';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  window: [],
});

export default function reduce(state = initialState, action = {}) {
  let payload = action.payload;
  switch (action.type) {
    case types.DIALOG_WINDOW_SET_WINDOW:
      let AddWindow = [...state.window];
      let AddItem = AddWindow.find(x => x.id == payload.id);
      if (AddWindow.indexOf(AddItem) > -1) {
        AddWindow[AddWindow.indexOf(AddItem)] = AddItem.merge({ visible: true, highlighted: true });
        return state.merge({ window: AddWindow });
      } else {
        payload.visible = true;
        payload.highlighted = true;
        return state.merge({ window: [...state.window, payload] });
      }

    case types.DIALOG_WINDOW_REMOVE_WINDOW:
      let RemoveWindow = [...state.window];
      let RemoveItem = RemoveWindow.find(x => x.id == payload);
      RemoveWindow[RemoveWindow.indexOf(RemoveItem)] = RemoveItem.merge({ visible: false, highlighted: false });
      return state.merge({ window: RemoveWindow });

    case types.DIALOG_WINDOW_HIGHLIGHTED_WINDOW:
      let ChangeWindow = [...state.window];

      let list = [];
      ChangeWindow.forEach(w => {
        list.push(w.merge({ highlighted: false }));
      });
      let item = list.find(x => x.id == payload);
      list[list.indexOf(item)] = item.merge({ highlighted: true });

      return state.merge({ window: list });

    case types.RESET_WINDOW:
      return initialState;

    default:
      return state;
  }
}
